module.exports = __webpack_public_path__ + "img/user.888e0066.png";